import { type FC } from 'react';
import { Fieldset, type MantineSize, Text } from '@mantine/core';
import { formatOrder, type PayinOrder } from '~/entities/payin';
import { KeyValuePair } from '~/shared/ui/KeyValuePair';
import { CopyInput } from '~/shared/ui/CopyInput';

interface RequisitesProps {
    requisites: PayinOrder['requisite'];
    size?: MantineSize;
}

export const Requisites: FC<RequisitesProps> = ({ requisites, size = 'sm' }) => {
    return (
        <Fieldset
            radius='lg'
            legend={
                <Text
                    size={size}
                    fw={700}
                >
                    Реквизиты
                </Text>
            }
        >
            {requisites?.card?.bank && (
                <KeyValuePair
                    size={size}
                    label='Банк'
                    value={
                        <CopyInput
                            size={size}
                            value={formatOrder.bank(requisites?.card.bank)}
                        />
                    }
                />
            )}

            {requisites?.card?.holder && (
                <KeyValuePair
                    size={size}
                    label='Владелец карты'
                    value={
                        <CopyInput
                            size={size}
                            value={requisites?.card?.holder}
                        />
                    }
                />
            )}

            {requisites?.card?.number && (
                <KeyValuePair
                    size={size}
                    label='Номер карты'
                    value={
                        <CopyInput
                            size={size}
                            value={requisites?.card?.number}
                        />
                    }
                />
            )}

            {requisites?.sbp?.bank && (
                <KeyValuePair
                    size={size}
                    label='Банк'
                    value={
                        <CopyInput
                            size={size}
                            value={formatOrder.bank(requisites?.sbp.bank)}
                        />
                    }
                />
            )}

            {requisites?.sbp?.phoneNumber && (
                <KeyValuePair
                    size={size}
                    label='Номер телефона'
                    value={
                        <CopyInput
                            size={size}
                            value={requisites?.sbp.phoneNumber}
                        />
                    }
                />
            )}

            {requisites?.crypto?.address && (
                <KeyValuePair
                    size={size}
                    label='Адрес кошелька'
                    value={
                        <CopyInput
                            size={size}
                            value={requisites.crypto.address}
                        />
                    }
                />
            )}

            {requisites?.crypto?.destinationTag && (
                <KeyValuePair
                    size={size}
                    label='Destionation tag'
                    value={
                        <CopyInput
                            size={size}
                            value={requisites.crypto.destinationTag}
                        />
                    }
                />
            )}
        </Fieldset>
    );
};
